<aside id="mainCollectionPointList" class="col-md-12 mb-0 h-100-margin">
    <div class="container-list h-100-margin">
        <div class="d-flex flex-wrap-reverse">
            <mat-form-field appearance="outline" class="col-md-6 px-0">
                <mat-label>Tercero <span class="optional">(Nombre o Documento)</span></mat-label>
                <input type="text" matInput [(ngModel)]="thirdPartyFilter">
            </mat-form-field>
            <div class="d-flex justify-content-end col-md-6 m-0 p-0 pb-3" permission-display
                [module]="permission.administration.module"
                [functionality]="permission.administration.createThirdParty">
                <button matTooltip="Crear Tercero" mat-raised-button color="primary"
                    class="bg-color-primary button-width-auto text-bold" (click)="createThirdParty()">
                    <i class="fas fa-plus-circle mr-2 d-none d-sm-inline"></i>
                    <span>Crear tercero</span>
                </button>
            </div>
        </div>
        <span class="separator-horizontal"></span>
        <div class="container-list-body">
            <div class="col-md-12 px-0 mb-md-0 mb-12"
                *ngFor="let thirdParty of listThirdParties | filterThirdParties:thirdPartyFilter">
                <app-third-party-item [thirdParty]="thirdParty"></app-third-party-item>
            </div>
        </div>
    </div>
</aside>